import { makeAutoObservable, runInAction } from 'mobx';
import client from '@/store/client';
import { HelperCore } from "@/common/helper";

const onlyWindows = true; //目前只做卫士的Windows版本
class Store {
  open = false;
  userSetting = {
    //floatBtn: true, // 侧边悬浮头像
    slipperySearch: true, // 划词工具栏
    shortcutKey: 'Alt + K', // 快捷键导航设置
  };
  settingShortCutKey = false;
  shortCutKeyCleared = false;
  show = () => {
    this.open = true;
  };
  hide = () => {
    this.open = false;
  };

  get placeholder() {
    return HelperCore.isMac() && !onlyWindows
      ? 'Control/Option/Command + 数字/字符'
      : 'Control/Shift/Alt + 数字/字符';
  }

  constructor() {
    makeAutoObservable(this);

    if(!HelperCore.IS_PROD){
      window._settingStore = this;
    }
  }
  updateSetting = (params, doSet) => {
    runInAction(() => {
      this.userSetting = {
        ...this.userSetting,
        ...params,
      };
    });
    if (doSet) {
      client.run('SetUserSetting', null, this.userSetting);
    }
  };

  getSetting = () => {
    client.run('GetUserSetting', userSetting => {
      HelperCore.log('GetUserSetting userSetting:', userSetting);
      settingStore.updateSetting(userSetting);
    });
  };

  setSlipperySearch = slipperySearch => {
    this.updateSetting(
      {
        slipperySearch,
      },
      true
    );
  };

  setShortCutKey = shortcutKey => {
    if (this.setShortCutKeyCleared) {
      this.setShortCutKeyCleared(false);
    }
    this.updateSetting(
      {
        shortcutKey,
      },
      true
    );
  };

  updateSettingShortCutKey = settingShortCutKey => {
    this.settingShortCutKey = settingShortCutKey;
    this.setShortCutKeyCleared(false);
  };

  setShortCutKeyCleared = shortCutKeyCleared => {
    this.shortCutKeyCleared = shortCutKeyCleared;
  };
}

const settingStore = new Store();
export default settingStore;
